var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMicrophone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.521,
    height: 14.004,
    viewBox: "0 0 7.521 14.004",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#fff;stroke-width:0.13px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.07 0.065)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.92)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M119.686,239.449l-.461-.033a3.015,3.015,0,0,1-3,2.792h-.462a3.015,3.015,0,0,1-3-2.791l-.461.033a3.479,3.479,0,0,0,3,3.186v2.347h-.87a.69.69,0,0,0-.62.383l-.335.669a.231.231,0,0,0,.207.335h4.625a.231.231,0,0,0,.208-.335l-.335-.669a.69.69,0,0,0-.622-.383h-.87v-2.347A3.479,3.479,0,0,0,119.686,239.449Zm-3.922,3.221h.462v2.312h-.462Zm1.8,2.775a.231.231,0,0,1,.207.128h0l.166.335h-3.876l.167-.335a.231.231,0,0,1,.207-.128Z",
    transform: "translate(-112.304 -239.416)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.916)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M147.006,0h-.462A2.546,2.546,0,0,0,144,2.544V6.706a2.546,2.546,0,0,0,2.543,2.544h.462a2.547,2.547,0,0,0,2.544-2.544V2.544A2.547,2.547,0,0,0,147.006,0Zm2.081,6.706a2.083,2.083,0,0,1-2.081,2.081h-.462a2.083,2.083,0,0,1-2.081-2.081V2.544A2.083,2.083,0,0,1,146.544.462h.462a2.083,2.083,0,0,1,2.081,2.081Z",
    transform: "translate(-144)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicrophone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/microphone.ea9249fe.svg";
export { ForwardRef as ReactComponent };